import React from 'react'
import Modal from 'react-bootstrap/Modal'
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton'
import ClassEditor from 'components/Store/ClassEditor'
import {useRouteMatch} from 'util/router'
import {deleteService} from 'store/actions/schedulingActions'
import { useDispatch } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';


function AddEditServiceModal(props) {

    const {show, onHide, toEdit} = props

    const match = useRouteMatch()

    return(
        <Modal
            centered
            // className={"modal-container custom-map-modal"}
            size="lg"
            // {...props}
            show={show}
            onHide={onHide}
            keyboard={false}
            backdrop={'static'}
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <div className="container">
                    { props.new ? (
                        <ClassEditor 
                        {...props}
                        newService={props.newService}
                        onHide={onHide}
                        />
                    ) : (
                        <ClassEditor 
                        {...props}
                        editService={toEdit}
                        onHide={onHide}
                        />
                    )}
                    
                </div>
                
        </Modal>
    )
}

function EditServiceButton(props) {

    const [open, setOpen] = React.useState(false)
    // React.useState(props.new ? true : false)
    
    const { toEdit } = props
 
    return (
        <div>
            <AddEditServiceModal 
            {...props}
            show={open}
            toEdit={toEdit}
            onHide={() => setOpen(false)}
            new={false}
            />
            <IconButton onClick={() => setOpen(true)}>
                <EditIcon/>    
            </IconButton>
            {/* <button onClick={() => setOpen(true)} className="btn btn-link">
                Edit
            </button> */}
        </div>
    );
}

export  {EditServiceButton}

function NewServiceButton(props) {

    const [open, setOpen] = React.useState(false)
 
    return (
        <div>
            <AddEditServiceModal 
            {...props}
            show={open}
            onHide={() => setOpen(false)}
            new={true}
            newService={true}
            />
            <button onClick={() => setOpen(true)} className="btn btn-primary">
                Add New
            </button>
            {/* <IconButton onClick={() => setOpen(true)}>
                <EditIcon/>    
            </IconButton> */}
            {/* <button onClick={() => setOpen(true)} className="btn btn-link">
                Edit
            </button> */}
        </div>
    );
}

export {NewServiceButton}

function DuplicateServiceButton(props) {

    const [open, setOpen] = React.useState(false)
 
    return (
        <div>
            <AddEditServiceModal 
            {...props}
            show={open}
            onHide={() => setOpen(false)}
            new={true}
            newService={props.toDuplicate}
            />
            <button onClick={() => setOpen(true)} className="btn btn-link">
                Duplicate
            </button>
        </div>
    );
}

export {DuplicateServiceButton}

function DeleteServiceButton(props) {

    const {toDelete} = props

    const [alert, setAlert] = React.useState(false)
    

    const dispatch = useDispatch()

    function handleDelete() {

        if (!toDelete.id) {
            window.alert("Unable to delete this service")
            return
        }


        dispatch(deleteService(toDelete))
            .then(() => {
                setAlert(null)
            })
            .catch((err) => {
                window.alert(err)
            })
        

    }

    function confirmDelete() {

        setAlert(
            <SweetAlert
            // warning
            showCancel
            confirmBtnText="Remove"
            confirmBtnBsStyle="danger"
            title="Are you sure you would like to remove this Template?"
            onConfirm={() => handleDelete()}
            onCancel={() => setAlert(null)}
            focusCancelBtn
            >
             {/* If you do we recommend you notify your students who have signed up. */}
            </SweetAlert>
        )
    }
 
    return (
        <div>
            {alert}
            <IconButton style={{color: "#ff4136"}} onClick={() => confirmDelete()}>
                <DeleteOutlineIcon/>    
            </IconButton>
        </div>
    );

}

export {DeleteServiceButton}

